
<div class="p-2 busy-overlay-parent" [ngClass]="isLoading?'disabled':''">

  <div *ngIf="isLoading" class="font-weight-bold busy-overlay">
    <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
  </div>

  <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
      {{errorMsg}}
      <div role="button" (click)="errorMsg=''"><i class="fa fa-times"></i></div>
  </div>

  <h5>Mismatched Buildings</h5>
  <accordion [isAnimated]="true">
    <accordion-group *ngFor="let building of buildingMismatchedPoints | keyvalue;" [heading]="building.value[0].hasDuplicate ? building.key + ' (Duplicate points in scouts)' : building.key">
      <ng-container *ngIf="building.value[0].hasDuplicate; else elseBlock1">
        <div class="list-group">
          <a class="list-group-item list-group-item-action active">
            Scouts With Duplicates
          </a>
          <a *ngFor="let scout of building.value[0].scoutList;" (click)="showScout(scout._id, scout)" class="list-group-item list-group-item-action">{{scout._id}}</a>
        </div>
      </ng-container>
      <ng-template #elseBlock1>
        <table class="table table-bordered table-sm">
          <thead>
              <tr>
                  <th>Point ID</th>
                  <th>Floor Number</th>
                  <th>Quadrant</th>
                  <th>Type</th>
                  <th>Dist From Window</th>
                  <th>Floor & Description</th>
                  <th>Location Description</th>
                  <th>Ref 1</th>
                  <th>Ref 2</th>
                  <th>Latitude</th>
                  <th>Longitude</th>
                  <th>Alt Ellipsoid (m)</th>
                  <th>Window Count</th>
                  <th>Floor to Ceiling</th>
                  <th>Clutter</th>
                  <th>HVAC</th>
              </tr>
          </thead>
          <tbody>
              <ng-container *ngFor="let point of building.value;">
                  <ng-container *ngIf="point.exists; else elseBlock">
                    <tr class="table-success">
                        <td *ngFor="let field of point.fields;" [title]="'From Scout - ' + point.scout._id" (dblclick)="showScoutPoint(point.scoutPath, point.scoutPoint, point.scout)">{{field.scoutValue}}</td>
                    </tr>
                    <tr>
                        <td *ngFor="let field of point.fields;" [ngClass]="field.match ? 'table-info' : 'table-danger'" style="padding-bottom: 1em;">{{field.rxValue}}</td>
                    </tr>
                    <tr>
                      <td>
                          &nbsp;
                      </td>
                    </tr>
                  </ng-container>
                  <ng-template #elseBlock>
                    <tr class="table-success">
                      <td *ngFor="let field of point.fields;" [title]="'From Scout - ' + point.scout._id" (dblclick)="showScoutPoint(point.scoutPath, point.scoutPoint, point.scout)">{{field.scoutValue}}</td>
                    </tr>
                    <tr style="padding-bottom: 1em;">
                      <td colspan="16" class="table-danger" style="padding-bottom: 1em;">{{point.id}} does not exist in OneSource</td>
                    </tr>
                    <tr>
                      <td>
                          &nbsp;
                      </td>
                    </tr>
                  </ng-template>
              </ng-container>
          </tbody>
        </table>
      </ng-template>
    </accordion-group>
  </accordion>
</div>
